export default __webpack_public_path__ + "static/media/GorditaRegular.40eb60c3.woff2";